module.exports = __webpack_public_path__ + "static/img/angularjs.e610362c.png";